// @flow

import styled from 'styled-components';
import type { Theme } from '../../../../types';
import { SEMIBOLD } from '../../../../helpers/fontWeight';

export const Title = styled<any, Theme>('h2')`
  color: ${props => props.theme.cart.titleColor};
  font-size: 1.5rem;
  margin-bottom: .25rem;
`;

export const SubTitle = styled<any, Theme>('h4')`
  color: ${props => props.theme.cart.subTitle.color};
  font-size: ${props => props.theme.cart.subTitle.fontSize};
  font-weight: ${SEMIBOLD};
`;

export default null;
